import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/task',
    name: 'task',
    component: () => import('../views/Task'),
    meta: {
      title: '三认服务'
    }
  },
  {
    path: '/add-task',
    name: 'addTask',
    component: () => import('../views/CreateTask')
  },
  {
    path: '/handle-task',
    name: 'handleTask',
    component: () => import('../views/OperaTask')
  },
  {
    path: '/acquisition-list',
    name: 'acquisitionList',
    component: () => import('../views/NoBuyList'),
    meta: {
      title: '姜妈赶集'
    }
  },
  {
    path: '/acquisition',
    name: 'acquisition',
    component: () => import('../views/Buy'),
    meta: {
      title: '姜妈赶集'
    }
  },
  {
    path: '/pend-acquisition',
    name: 'pendAcquisition',
    component: () => import('../views/PendBuy'),
    meta: {
      title: '姜妈赶集'
    }
  },
  //
  {
    path: '/store',
    name: 'store',
    component: () => import('../views/Store'),
    redirect: '/home',
    children: [
      {
        path: '/cart',
        name: 'cart',
        component: () => import('../views/Cart')
      },
      {
        path: '/mine',
        name: 'mine',
        component: () => import('../views/Mine')
      },
      {
        path: '/detail',
        name: 'detail',
        component: () => import('../views/Detail')
      },
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/List')
      }

    ]

  },

]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title == undefined ? '大下姜共同富裕' : to.meta.title
  next()
})

export default router
